import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';


class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fileurl: ""
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }


    SetData(data) {
        this.setState({
            fileurl: data.url
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.plantillas.detail}
                postUrl={api.proyectos.config.plantillas.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}

                missingIdMessage={"Debe seleccionar una fila."}
                successMessage={"La Plantilla ha sido eliminada con éxito."}
                title={"Eliminar Plantilla"}
                buttonTitle={"Eliminar Plantilla"}
                buttonIcon={"fa fa-trash fa-lg"}

                saveButton={true}
                closeButton={true}
                danger={true}
                saveButtonLabel={"Eliminar"}
                buttonClass={"btn-danger"}
                onGotData={(data) => this.SetData(data)}>
                <Row>
                    <Col className="col-2">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="nombre" disabled={true}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Archivo</Label>
                    </Col>
                    <Col className="col-10">
                        <Label><a target="_blank" href={api.BASE_URL + this.state.fileurl}>DESCARGAR PLANILLA</a></Label>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Proyectos_Plantillas/Delete.js